<script lang="ts" setup>
import { useAppStore } from '~/store/app/app'
import { SnackbarType } from '~/store/app/app.types'

const appStore = useAppStore()
</script>
<template>
  <v-snackbar
    v-model="appStore.snackbar.show"
    timeout="2000"
    :location="appStore.snackbar.location"
    :color="
      appStore.snackbar.type === SnackbarType.SUCCESS ? 'success' : '#000000'
    "
    class="snackbar"
  >
    <div class="snackbar__message">
      <nuxt-img
        :src="
          appStore.snackbar.type === SnackbarType.SUCCESS
            ? '/icon-success.svg'
            : '/icon-attention.svg'
        "
        :alt="appStore.snackbar.message"
        class="snackbar__message-icon"
      />
      <span class="snackbar__message-text">
        {{ appStore.snackbar.message }}
      </span>
    </div>
  </v-snackbar>
</template>

<style lang="scss" scoped>
:deep(.v-snackbar__wrapper) {
  max-width: 600px;
  border-radius: 6px;
}

.snackbar {
  position: fixed !important;
  top: 134px;
  z-index: 10001;

  &__message {
    display: flex;
    align-items: center;
    &-icon {
      margin-right: 10px;
    }
    &-text {
      text-align: left;

      @include font-sz-weight(14px, 700);
    }
  }

  @include media('<tablet') {
    top: 60px;
  }
}
</style>
